import React from 'react'

export default function Loading(props: {
  data: KnowledgeRetrievalOutput,
}) {
  return (
    <div className='chat-block__loading'>{props.data.outputs.summary || "生成中"}
      <div className='chat-block__loading-dot' style={{
        backgroundColor: '#3BA7FF'
      }}></div>
      <div className='chat-block__loading-dot' style={{
        backgroundColor: '#FC0BFF'
      }}></div>
      <div className='chat-block__loading-dot' style={{
        backgroundColor: '#D9C0EC'
      }}></div>
      {/* <div className='dot-elastic'></div> */}
    </div>
  )
}
